// extracted by mini-css-extract-plugin
export default {"last_event_time":"styles-module_last_event_time_RLORiX","lastEventTime":"styles-module_last_event_time_RLORiX"};